"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * Prepares a string to be used as a segment in EID by replacing spaces with underscores and lowercasing.
 *
 * @param {String} eidSegment A text to be used as a segment in EID
 * @returns {String} Normalized EID segment.
 * @public
 */
const normalizeEidSegment = eidSegment => {
  return eidSegment.toLowerCase().replace(/ /g, '_');
};
var _default = exports.default = normalizeEidSegment;